import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import { mainContractorServices, portfolioItems } from "../data";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useMediaQuery } from "@mui/material";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import Portfolio from "../components/Portfolio";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";

const MainContractorServices = () => {
  const navigate = useNavigate();
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [isBottomScreen, setIsBottomScreen] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");
  let hideTimeout;

  window.onpopstate = () => {
    navigate("/#videoSlider");
  };

  useEffect(() => {
    const handleMouseMove = () => {
      showScrollIndicator();
    };

    const handleTouchStart = () => {
      showScrollIndicator();
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchstart", handleTouchStart);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchstart", handleTouchStart);
      clearTimeout(hideTimeout);
    };
  }, [isBottomScreen]);

  const handleIconOnClick = (navLink) => {
    window.location.href = navLink;
  };

  const handleWhatsappClick = () => {
    window.location.href = "https://wa.link/hj33t3";
  };

  const ref = useRef();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["end end", "start start"],
  });

  const scaleX = useSpring(scrollYProgress, {
    stiffness: 10,
    damping: 30,
  });

  const showScrollIndicator = () => {
    if (isBottomScreen) {
      return null;
    } else {
      setShowScrollDown(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setShowScrollDown(false);
      }, 2000);
    }
  };

  const RenderFooterContainer = () => {
    const socialMedia = [
      {
        id: 1,
        icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png",
        action:
          "https://www.instagram.com/luxedesign.firm?igsh=cmFsYzF4a3BqaDdm",
      },
      {
        id: 2,
        icon: "https://www.edigitalagency.com.au/wp-content/uploads/whatsapp-logo-png-green-square.png",
        action: "https://wa.link/hj33t3",
      },
    ];

    return (
      <FooterContainer>
        <SocialContainer>
          {socialMedia.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                handleIconOnClick(item.action);
              }}
            >
              <FooterImg src={item.icon} />
            </div>
          ))}
        </SocialContainer>
        <FooterTitle>LUXE INTERIOR DESIGN FIRM</FooterTitle>
        <FooterDescription>
          Design & Build | Interior Design Firms Malaysia/Singapore | Interior
          Design Companies Malaysia/Singapore | Interior Design Companies Near
          Me | Top Interior Design Companies | Best Interior Design Company
          Commercial Interior Design | Commercial Contractor Malaysia |
          Renovation Company | Home Remodeling Contractors | Id Contractors |
          Fit Out Company | Corporate Interior Design | Retails & Commercial
          Electrical Maintenance | Shopping Mall Maintenance
        </FooterDescription>
      </FooterContainer>
    );
  };

  const handleScroll = (_event) => {
    const target = _event.target;
    const targetChanges = target.scrollHeight - target.scrollTop;
    if (targetChanges - target.clientHeight < 1) {
      setShowScrollDown(false);
      setIsBottomScreen(true);
    } else {
      setIsBottomScreen(false);
    }
  };

  return (
    <Container>
      <StickyHeader>
        {/* <Announcement /> */}
        <Navbar isOtherScreen={true} />
      </StickyHeader>
      {isMobile && (
        <LeftArrowIcon>
          <KeyboardBackspaceIcon
            style={{ fontSize: 24 }}
            onClick={() => {
              navigate("/#videoSlider");
            }}
          />
        </LeftArrowIcon>
      )}
      <ServiceContainer
        onScroll={(event) => {
          handleScroll(event);
        }}
      >
        <ServiceHeader>
          <ServiceImage
            src={`/img/services/mainContractor/${mainContractorServices.serviceImg}`}
          />
          <ServiceTitle>{mainContractorServices.title}</ServiceTitle>
          <ServiceDescription
            dangerouslySetInnerHTML={{
              __html: mainContractorServices.description,
            }}
          />
        </ServiceHeader>

        <PortfolioWrapper ref={ref}>
          <div className="progress" id="portfoliosSection">
            <h1>LUXE SERVICES</h1>
            <ProgressBar style={{ scaleX }} />
          </div>
          {mainContractorServices.workList.map((item) => (
            <PortfolioContainer key={item.id}>
              <Portfolio hideButton productId={item.id} item={item} />
            </PortfolioContainer>
          ))}
        </PortfolioWrapper>
        <RenderFooterContainer />
      </ServiceContainer>
      {showScrollDown && (
        <>
          <ScrollDownLeftIcon>
            <ScrollDown>
              <KeyboardDoubleArrowDown htmlColor={"white"} />
            </ScrollDown>
            <ScrollDownLabel>Scroll down</ScrollDownLabel>
          </ScrollDownLeftIcon>

          <ScrollDownRightIcon>
            <ScrollDown>
              <KeyboardDoubleArrowDown htmlColor={"white"} />
            </ScrollDown>
            <ScrollDownLabel>Scroll down</ScrollDownLabel>
          </ScrollDownRightIcon>
        </>
      )}
      <WhatsappContainer onClick={handleWhatsappClick}>
        <WhatsappIcon src="/whatsappIcon.svg" />
      </WhatsappContainer>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
`;

const StickyHeader = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 3;
`;

const LeftArrowIcon = styled.div`
  position: absolute;
  left: 7px;
  top: 35px;
`;

const ServiceContainer = styled.div`
  height: 100vh;
  background-color: #f5fbfd;
  scroll-snap-type: y mandatory;
  scroll-snap-stop: inherit;
  scroll-behavior: smooth;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ServiceHeader = styled.div`
  padding: 60px 80px 60px 80px;
  align-items: center;
  scroll-snap-align: center;
  @media (max-width: 768px) {
    height: 60vh;
    padding: 60px 30px 130px 30px;
  }
`;

const ServiceImage = styled.img`
  height: 300px;
  width: 100%;
  object-fit: cover;
  @media (max-width: 768px) {
    height: 150px;
  }
`;

const ServiceTitle = styled.h2`
  font-size: 54px;
  font-style: normal;
  font-family: "Kestrel";
  margin-top: 12px;
  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const ServiceDescription = styled.p`
  font-size: 20px;
  white-space: pre-wrap;
  color: #3b3b3b;
  margin-top: 5px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const PortfolioWrapper = styled.div`
  background-color: #f5fbfd;
  position: relative;
  .progress {
    position: sticky;
    top: 0;
    left: 0;
    padding-top: 50px;
    text-align: center;
    font-size: 32px;

    @media (max-width: 768px) {
      font-size: 20px;
      top: 5%;
    }

    .progressBar {
      height: 10px;
      background-color: white;
    }
  }
`;

const ProgressBar = styled(motion.div)`
  height: 10px;
  background-color: black;
`;

const PortfolioContainer = styled(motion.div)``;

const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 15px;
  margin-bottom: 5px;
  cursor: pointer;
`;

const FooterImg = styled.img`
  display: flex;
  height: 35px;
  width: 35px;
  &:hover {
    opacity: 0.6;
  }
  @media (max-width: 768px) {
    height: 20px;
    width: 20px;
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 130px;
  scroll-snap-align: center;
  /* margin-top: 50px; */
  padding: 0 150px 0px 150px;
  justify-content: center;
  row-gap: 5px;
  background-color: lightgray;
  margin-top: 300px;
  -webkit-tap-highlight-color: transparent;
  @media (max-width: 768px) {
    padding: 0px 20px 0px 20px;
  }
`;

const FooterTitle = styled.h4`
  font-size: 14px;
  line-height: 13px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const FooterDescription = styled.p`
  font-size: 14px;
  line-height: 15px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 7px;
    line-height: 10px;
  }
`;

const ScrollDownLeftIcon = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 10px;
  left: 31%;
  @media (max-width: 768px) {
    left: 15%;
  }
`;

const ScrollDownRightIcon = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 10px;
  right: 31%;
  @media (max-width: 768px) {
    right: 15%;
  }
`;

const ScrollDown = styled.div`
  background-color: black;
  padding: 5px;
  border-radius: 50%;
  display: flex;
`;

const ScrollDownLabel = styled.p`
  font-size: 14px;
  margin-top: 5px;
  color: black;
`;

const WhatsappContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 5;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
    transform: scale(1.2);
  }
  @media (max-width: 768px) {
    bottom: 40px;
    right: 15px;
  }
`;

const WhatsappIcon = styled.img`
  display: flex;
  height: 50px;
  width: 50px;
  @media (max-width: 768px) {
    height: 45px;
    width: 45px;
  }
`;

export default MainContractorServices;
